import React, { FC, useState } from 'react';
import styled from 'styled-components';
import { LogoWithTextImg, ChevronDownIcon } from '~/img';

import MobileHeaderContainer from './MobileHeaderContainer';
import MobileMenu from './MobileMenu';

const MOBILE_HEADER_HEIGHT = 64;

const MobileHeader: FC = () => {
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  return (
    <MobileHeaderContainer open={open} onClose={handleClose} headerHeight={MOBILE_HEADER_HEIGHT}>
      <Container className="MobileHeader" open={open} onClick={handleToggle}>
        <LogoWithTextImg className="MobileHeader-Logo" />
        <ChevronDownIcon className="MobileHeader-DownIcon" />
      </Container>
      <MobileMenu onClose={handleClose} />
    </MobileHeaderContainer>
  );
};

const Container = styled.div<{ open: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  width: 100%;
  height: ${MOBILE_HEADER_HEIGHT}px;
  box-shadow: 0px 4px 4px rgba(164, 175, 183, 0.05);
  .MobileHeader-Logo {
    height: 32px;
  }
  .MobileHeader-DownIcon {
    font-size: 32px;
    transform: ${({ open }) => (open ? 'rotate(0deg)' : 'rotate(180deg)')};
    transition: 0.3s cubic-bezier(0.7, 0.3, 0.1, 1);
  }
`;

export default MobileHeader;
